import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { stringify } from 'query-string';

import TestDetailsModalComponent from './../Components/TestDetailsModalComponent.jsx';
import {
  fetchFailedTestArtifactsByJobIds,
  modal as modalActions
} from './../actions';
import {
  getScenariosByDispatcherId,
  getFailedTestArtifactsByJobId,
  getModalVisibility,
  getModalInfoByOwner,
  getScenarioByRunner,
  routerExtraReducer
} from './../reducers';
import { owners } from './../helpers/modals';
import { HOST } from '../helpers/index';
import { dispatcher as dispatcherSelectors } from '../selectors';

export class TestDetailsModalContainer extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    modalUrl: PropTypes.string.isRequired,
    fetchFailedTestArtifactsByJobIds: PropTypes.func.isRequired,
    nonEmptyRunnerScenarios: PropTypes.array
  };

  componentDidUpdate() {
    if (this.props.nonEmptyRunnerScenarios !== undefined &&
      this.props.nonEmptyRunnerScenarios.length !== 0) {
      const failedScenarios = this.props.nonEmptyRunnerScenarios ?
        this.props.nonEmptyRunnerScenarios.filter(s => s.status === 'FAILED') : [];
      this.props.fetchFailedTestArtifactsByJobIds(failedScenarios.map(s => s.runner));
    }
  }

  render() {
    if (this.props.nonEmptyRunnerScenarios === undefined) {
      return (null);
    }
    return (
      <TestDetailsModalComponent
        {...this.props}
      />
    );
  }
}

export const mapStateToProps = (state) => {
  const modalInfo = getModalInfoByOwner(state, owners.testArtifacts);
  const scenario = getScenarioByRunner(state, modalInfo.runner);
  const jobInfo = dispatcherSelectors.getDispatcherJobInfo(state);
  const dispatcherId = jobInfo ? jobInfo.dispatcherId : '';
  const scenarios = dispatcherId ?
    getScenariosByDispatcherId(state, dispatcherId) : [];
  const nonEmptyRunnerScenarios = scenarios ? scenarios.filter(s => s.runner) : [];

  const paramsExcludingExpanded = routerExtraReducer
    .sortQueryParamsByConcerning(state, ['ex']).other;
  const modalUrl = `${HOST}/${routerExtraReducer.getPathName(state)}` +
    `?${stringify(paramsExcludingExpanded)}&rn=${modalInfo.runner}`;

  const props = {
    visible: getModalVisibility(state, owners.testArtifacts),
    runner: modalInfo.runner,
    modalUrl,
    scenarioName: scenario ? scenario.name : '',
    failedTestArtifacts: getFailedTestArtifactsByJobId(state, modalInfo.runner),
    nonEmptyRunnerScenarios
  };
  return props;
};

export default connect(
  mapStateToProps,
  {
    fetchFailedTestArtifactsByJobIds,
    onHide: () => modalActions.showTestArtifactsModal(false)
  }
)(TestDetailsModalContainer);


// WEBPACK FOOTER //
// src/Containers/TestDetailsModalContainer.jsx